import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const TrackList = ({ tracks, onDragEnd, onEditTrack, onRemoveTrack }) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <div className="added-tracks" {...provided.droppableProps} ref={provided.innerRef}>
            {tracks.map((track, i) => (
              <Draggable key={track.id} draggableId={track.id} index={i}>
                {(provided) => (
                  <div
                    className="added-track"
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <div className="added-track-right">
                      <i className="fi fi-sr-grip-dots drag-track-btn"></i>
                      {i + 1 < 10 ? `0${i + 1}` : i + 1}. {track.title}
                    </div>
                    <div className="added-track-left">
                      <i 
                        className="fi fi-rr-pencil" 
                        data-bs-toggle="modal" 
                        data-bs-target="#editTrackModal"
                        onClick={() => onEditTrack(track, i)}
                      ></i>
                      <i 
                        className="fi fi-sr-cross"
                        onClick={() => onRemoveTrack(i)}
                      ></i>
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default TrackList; 